import CategoryOrProductQAReport from "./CategoryOrProductQAReport.component";

export default CategoryOrProductQAReport;
